var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('div',{staticClass:"banner-wrapper"},[_c('img',{staticClass:"banner pt-0",attrs:{"src":_vm.$settings.url(_vm.$settings.banner)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }